import { render, staticRenderFns } from "./AppSubMenu.vue?vue&type=template&id=0834a7e6&functional=true&"
import script from "./AppSubMenu.vue?vue&type=script&lang=ts&"
export * from "./AppSubMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0834a7e6')) {
      api.createRecord('0834a7e6', component.options)
    } else {
      api.rerender('0834a7e6', component.options)
    }
    module.hot.accept("./AppSubMenu.vue?vue&type=template&id=0834a7e6&functional=true&", function () {
      api.rerender('0834a7e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppContainer/AppSubMenu.vue"
export default component.exports